var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { countryOptions, countryRegionsByCode, getDefaultCountry, isNumericPostalCode } from '../../../utils/countries';
import { alphanumericZipFields, alphanumericZipProps, handleKeydown, makeUpdateZipFields, numericZipFields, numericZipProps, } from '../../../utils/form';
import { unmask, nameRegex } from '../../../utils/shared';
import { makeFormContext } from './Form';
export var defaultCountry = getDefaultCountry();
export var defaultRegions = countryRegionsByCode[defaultCountry];
var phoneRegex = /^\d{0,10}$/g;
var name = {
    props: {
        id: 'name',
        name: 'name',
        autoCorrect: 'off',
        spellCheck: false,
        placeholder: 'Name',
        autoComplete: 'shipping name',
    },
    blurError: function (value) {
        if (value && !value.match(nameRegex)) {
            return 'Your name is incomplete.';
        }
        return '';
    },
    changeError: function () { return ''; },
    required: true,
    fieldNames: ['billingAddress.firstName', 'billingAddress.lastName'],
};
var zip = __assign({ props: __assign({ id: 'zip', name: 'zip', autoCorrect: 'off', spellCheck: false, placeholder: 'ZIP', autoComplete: 'shipping postal-code', onKeyDown: handleKeydown }, (isNumericPostalCode(defaultCountry) ? numericZipProps : alphanumericZipProps)), required: true, fieldNames: ['billingAddress.postalCode'] }, (isNumericPostalCode(defaultCountry) ? numericZipFields : alphanumericZipFields));
var country = {
    props: {
        id: 'country',
        name: 'country',
        autoCorrect: 'off',
        spellCheck: false,
        placeholder: 'Country',
        autoComplete: 'shipping country',
        defaultValue: defaultCountry,
        onInput: makeUpdateZipFields(zip),
    },
    type: 'select',
    options: countryOptions,
    required: true,
    fieldNames: ['billingAddress.country'],
};
var address = {
    props: {
        id: 'address',
        name: 'address',
        autoCorrect: 'off',
        spellCheck: false,
        placeholder: 'Address',
        autoComplete: 'shipping address-line1',
    },
    required: true,
};
var address2 = {
    props: {
        id: 'address2',
        name: 'address2',
        autoCorrect: 'off',
        spellCheck: false,
        placeholder: 'Address line 2',
        autoComplete: 'shipping address-line2',
    },
};
var city = {
    props: {
        id: 'city',
        name: 'city',
        autoCorrect: 'off',
        spellCheck: false,
        placeholder: 'City',
        autoComplete: 'shipping address-level2',
    },
    required: true,
};
var state = {
    type: 'select',
    options: defaultRegions,
    props: {
        id: 'state',
        name: 'state',
        autoCorrect: 'off',
        spellCheck: false,
        placeholder: 'State',
        autoComplete: 'shipping address-level1',
    },
    required: true,
};
var phone = {
    props: {
        id: 'phone',
        name: 'phone',
        autoCorrect: 'off',
        spellCheck: false,
        placeholder: '(201) 555-0123',
        autoComplete: 'tel',
        onKeyDown: handleKeydown,
    },
    // required: true,
    pattern: phoneRegex,
    mask: phoneMask,
    unmask: unmask,
    blurError: function (value) {
        var unmasked = unmask(value);
        if (unmasked && unmasked.length < 10) {
            return 'Your phone is incomplete.';
        }
        return '';
    },
    changeError: function () { return ''; },
};
export var shippingValues = {
    name: name,
    country: country,
    address: address,
    address2: address2,
    city: city,
    zip: zip,
    state: state,
    phone: phone,
};
export var ShippingContext = (_a = makeFormContext({
    name: 'Shipping',
    formValues: shippingValues,
}), _a.Context), ShippingProvider = _a.Provider, useShipping = _a.useForm;
function phoneMask(value) {
    if (value.length > 6) {
        return "(".concat(value.slice(0, 3), ") ").concat(value.slice(3, 6), " - ").concat(value.slice(6));
    }
    if (value.length > 3) {
        return "(".concat(value.slice(0, 3), ") ").concat(value.slice(3, 6));
    }
    return value;
}
//# sourceMappingURL=Shipping.js.map